import { memo } from 'react';
import { useMiningStatus } from '../../hooks/useMiningStatus';
import styles from './MiningInfo.module.css';
import GaerIcon from "/dreamcoin-gaer.svg";
import DreamCoinLogo from "/dreamcoin-logo-miningbar.svg";

const MiningInfo = memo(() => {
  const {
    statusText,
    // formattedStart,
    // formattedEnd,
    // formattedOriginalEnd,
    miningStatus,
    timeLeft,
    rewards
  } = useMiningStatus();

  const stopAnimation = miningStatus === 'claim';
  const isDone = miningStatus === 'claim';

  return (
    <>
    <div className={styles.infoContainer}>
      <div className={styles.iconContainer}>
        <img 
            className={styles.gaerIcon}
            style={{ animation: stopAnimation ? `${styles.rotate} 1.5s infinite paused` : `${styles.rotate} 1.5s infinite` }}  
            src={GaerIcon} 
            alt="coin" 
        />
        <img 
            className={styles.dreamCoinLogo}
            style={{ animation: stopAnimation ? `${styles.pulse} 1.5s infinite paused` : `${styles.pulse} 1.5s infinite` }}
            src={DreamCoinLogo} 
            alt="coin" 
        />
      </div>
      <div className={styles.divider} />
      <div className={styles.textContainer}>
        <div className={styles.statusContainer}>
        <div className={styles.statusText}>{statusText}</div>
        <div className={styles.timeLeft}> {isDone ? '' : timeLeft}</div>
        </div>
        <div className={styles.rewardsContainer}>
          <div>{rewards.currentDC.toFixed(3)} DC | {rewards.currentUSDT.toFixed(4)} USDT</div>
        </div>
      </div>
    </div>
    </>
  );
});

MiningInfo.displayName = 'MiningInfo';

export default MiningInfo;
